import { FaCopyright } from "react-icons/fa";

const Footer = () => {
  return (
    <section className="bg-lightAqua rounded-t-lg font-semibold text-lg text-gray-50">
      <div className="max-w-7xl mx-auto px-4 my-2 flex justify-center items-center gap-2">
        Copyrights <FaCopyright /> Spark4AI.com 2024
      </div>
    </section>
  )
}

export default Footer